import { baseUrl } from "./api";

export function companyMonthlyIncome() {
  return `${baseUrl()}/api/v2/data_points/companymo1`;
}



// WEBPACK FOOTER //
// ./src/features/shared/apiUrls.js